export enum GridCellRendererEnum {
    GridCellList = 'GridCellList',
    GridCheckbox = 'GridCheckbox',
    GridSlider = 'GridSlider',
    GridCellLargeText = 'GridCellLargeText',
    GridCellLargeTextScroll = 'GridCellLargeTextScroll',
    GridCellLongText = 'GridCellLongText',
    DataRequestDate = 'DataRequestDate',
    DataRequestStatus = 'DataRequestStatus',
    DataRequestTitle = 'DataRequestTitle',
    GridDataStudyButton = 'GridDataStudyButton',
    GridCellDateTime = 'GridCellDateTime',
    GridCellDate = 'GridCellDate',
    GridCustomDisplay = 'GridCustomDisplay',
    GridCellErrorIcon = 'GridCellErrorIcon',
    GridCellYesNo = 'GridCellYesNo'
}
